// extracted by mini-css-extract-plugin
module.exports = {"settings":"GameSettings_settings__2bRr1","title":"GameSettings_title__S_4xz"};